import { ZIPCODE_FORMAT } from '../../constants';
import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'ProjectID',
    field: 'projectID',
    filter: 'text',
    hide: true,
  },
  {
    title: 'Project',
    field: 'projectName',
    filter: 'text',
    searchable: true,
    navigate: true,
    width: '200',
  }
  ,
  {
    title: 'Project Code',
    field: 'projectCode',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  {
    title: 'Builder Code',
    field: 'builderCode',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  {
    title: 'Customer',
    field: 'customerName',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  {
    title: 'Office',
    field: 'officeName',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  {
    title: 'City',
    field: 'city',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  {
    title: 'State',
    field: 'stateName',
    filter: 'text',
    width: '200',
  },
  {
    title: 'Zip Code',
    field: 'zipcode',
    filter: 'text',
    width: '200',
    formatPattern: ZIPCODE_FORMAT,
  },
  {
    title: 'Municipalities',
    field: 'municipalities',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  {
    title: 'Lots/Units',
    field: 'unitsCount',
    filter: 'text',
    width: '120',
  },
  {
    title: 'Work Orders',
    field: 'workOrderCount',
    filter: 'numeric',
    searchable: true,
    width: '150',
  },
  {
    title: 'Contacts',
    field: 'projectContactsCount',
    filter: 'text',
    searchable: true,
    width: '100',
  },
  {
    title: 'Forecast Start Date',
    field: 'forecastStartDate',
    filter: 'text',
    hide: false,
    searchable: true,
    width: '220',
  },
  {
    title: 'Estimated Starts per Month',
    field: 'estimatedStartsPerMonth',
    filter: 'numeric',
    hide: false,
    searchable: true,
    width: '220',
  },
];
